import React from 'react';
export function FormField({ label, error, required, hint, children }) {
  return (
    <div className="space-y-1">
      {label && <label className="block text-sm font-medium text-gray-700">{label}{required && <span className="text-red-500 ml-0.5">*</span>}</label>}
      {children}
      {error && <p className="text-xs text-red-500">{error}</p>}
      {hint && !error && <p className="text-xs text-gray-400">{hint}</p>}
    </div>
  );
}
const cls = "w-full px-3 py-2 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all bg-white";
export const Input    = React.forwardRef((p, r) => <input    ref={r} className={cls + ' ' + (p.className||'')} {...p} className={undefined}/>);
export const Select   = React.forwardRef((p, r) => <select   ref={r} className={cls + ' ' + (p.className||'')} {...p} className={undefined}/>);
export const Textarea = React.forwardRef((p, r) => <textarea ref={r} rows={3} className={cls + ' resize-none ' + (p.className||'')} {...p} className={undefined}/>);